export enum LinkAdDialogTitle {
  FailedToLink = 'Failed to link ad',
}
